import { MailDestinataireContactInput } from './mail-destinataire-contact-input';

export class MailDestinataireInput {
  statut?: string; // Statut description
  action?: string; //  Action description
  transmisDate?: string; // ($date-time)
  echeance?: string; // ($date - time)
  message?: string;
  accuseDeReponse?: boolean; // Accuse de reponse / Suivi de reponse
  libre?: string | null;
  serviceProprietaireId?: number; //  Au nom du service expéditeur
  contacts: MailDestinataireContactInput[];
  serviceIds?: number[];
  groupeIds?: number[];

  constructor(data?) {
    Object.assign(this, data);
    if (data.accuseDeReponse === null) this.accuseDeReponse = false;
  }
}
